import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { PageHeader } from '../components/PageParts';
import { formatDateTime } from '../utils/format';
import { FileText, Users, Truck, Building2, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

const ACTION_COLORS = {
  create: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
  update: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  delete: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
};

export default function Settings() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/logs', { params: { limit: 30 } }).then(r => setLogs(r.data.items)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHeader title="Configurações" subtitle="Administração do sistema" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[
          { to: '/usuarios', icon: Users, title: 'Usuários', desc: 'Gerenciar usuários' },
          { to: '/perfis', icon: Shield, title: 'Perfis', desc: 'Permissões e acessos' },
          { to: '/empresa', icon: Building2, title: 'Empresa', desc: 'Dados cadastrais' },
          { to: '/frota', icon: Truck, title: 'Frota', desc: 'Cadastro de veículos' },
        ].map(c => (
          <Link key={c.to} to={c.to} className="card-hover block rounded-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 p-5">
            <div className="h-10 w-10 rounded-lg bg-red-50 dark:bg-red-950/30 text-brand flex items-center justify-center mb-3">
              <c.icon className="h-5 w-5" />
            </div>
            <p className="font-semibold">{c.title}</p>
            <p className="text-xs text-neutral-500 mt-0.5">{c.desc}</p>
          </Link>
        ))}
      </div>

      <div className="rounded-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 overflow-hidden">
        <div className="px-5 py-4 border-b border-neutral-200 dark:border-neutral-800 flex items-center gap-2">
          <FileText className="h-5 w-5 text-brand" />
          <h3 className="font-semibold">Logs de Atividade</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-neutral-50 dark:bg-neutral-900/60 text-neutral-500 text-xs uppercase tracking-wider">
              <tr>
                <th className="text-left px-4 py-3 font-medium">Data/Hora</th>
                <th className="text-left px-4 py-3 font-medium">Usuário</th>
                <th className="text-left px-4 py-3 font-medium">IP</th>
                <th className="text-left px-4 py-3 font-medium">Ação</th>
                <th className="text-left px-4 py-3 font-medium">Módulo</th>
                <th className="text-left px-4 py-3 font-medium">Endpoint</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-neutral-100 dark:divide-neutral-800">
              {loading ? Array.from({ length: 5 }).map((_, i) => (
                <tr key={i}><td colSpan={6} className="p-4"><div className="h-6 rounded shimmer" /></td></tr>
              )) : logs.length === 0 ? (
                <tr><td colSpan={6} className="px-4 py-8 text-center text-neutral-500">Nenhum log registrado ainda</td></tr>
              ) : logs.map(l => (
                <tr key={l.id} className="tr-hover">
                  <td className="px-4 py-2.5 text-xs">{formatDateTime(l.timestamp)}</td>
                  <td className="px-4 py-2.5">{l.user_email}</td>
                  <td className="px-4 py-2.5 font-mono text-xs">{l.ip}</td>
                  <td className="px-4 py-2.5"><span className={`px-2 py-0.5 rounded-full text-[11px] font-medium ${ACTION_COLORS[l.action] || 'bg-neutral-100 text-neutral-700'}`}>{l.action}</span></td>
                  <td className="px-4 py-2.5">{l.module}</td>
                  <td className="px-4 py-2.5 font-mono text-xs text-neutral-500">{l.method} {l.path}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
